<template>
  <div
    v-if="school && inspectieRapporten.length"
    class="content-block"
  >
    <h3 class="content-block-title">
      Inspectierapport
    </h3>

    <template v-for="(inspectieRapport, index) in inspectieRapporten">
      <a
        :key="index"
        target="_blank"
        :href="inspectierapportUrlForSchool(inspectieRapport)"
      >
        {{ inspectieRapport.bestandsnaam }} - {{ inspectieRapport.jaar }}
      </a>
    </template>
  </div>
</template>
<script>
import { inspectierapportUrl } from '@/library/url-helpers';
import scholenRepository from '../../repositories/scholenRepository';

export default {
  props: {
    school: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      baseURL: process.env.VUE_APP_BASE_URL,
      inspectieRapporten: [],
    };
  },
  created() {
    scholenRepository
      .listInspectieRapporten({ 'where[sbs_scholen_id]': this.school.id })
      .then(({ data }) => {
        this.inspectieRapporten = data.sort((a, b) => {
          const aDateStr = this.$options.filters.retartedDate(a.jaar);
          const bDateStr = this.$options.filters.retartedDate(b.jaar);
          if (new Date(aDateStr) > new Date(bDateStr)) {
            return -1;
          }
          return 1;
        });
      });
  },
  methods: {
    inspectierapportUrlForSchool(inspectierapport) {
      return inspectierapportUrl(inspectierapport, `${this.baseURL}/uploads/inspectierapporten/${this.school.type}/${inspectierapport.bestands_locatie}`);
    },
  },
};
</script>
<style lang="scss" scoped>
a {
  display: block;
  margin-bottom: 8px;
}
</style>
